// extracted by mini-css-extract-plugin
export var dataCell = "_m1-2";
export var dataRow = "_m1-0";
export var headerRow = "_m1-1";